import React, { useState } from 'react'
import './Login.css';

import Loader from '../../../components/Loader/Loader';

const Login = ({ authenticate, loading }) => {

    const [authenticating, setAuthenticating] = useState(false)
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [error, setError] = useState("")

    const handleAuthentication = async (event) => {
        event.preventDefault()
        setError("")

        if (!username.trim() || !password) {
            setError('Username and password are required.')
            return
        }

        setAuthenticating(true)
        try {
            await authenticate({ username, password })
        } catch (authenticationError) {
            setError(authenticationError.message || 'We could not sign you in. Please try again.')
        } finally {
            setAuthenticating(false)
        }
    }

    return (
        <section className="section-header account-page">
            <div className="view-container">
            {
                loading ? <Loader className="page-loader" /> :
                <>
                    <h1>Model<span>Login</span></h1>
                    <p>Please authenticate to manage your model profile.</p>
                    <form className="login-form" onSubmit={handleAuthentication} noValidate>
                        <div className="input-item">
                            <label htmlFor="login-username">Username/Email</label>
                            <input
                                id="login-username"
                                name="username"
                                type="text"
                                autoComplete="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>
                        <div className="input-item">
                            <label htmlFor="login-password">Password</label>
                            <input
                                id="login-password"
                                name="password"
                                type="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        {error && <p className="login-error" role="alert">{error}</p>}
                        <div className="city-selector">
                            <button type="submit" disabled={authenticating}>
                                {authenticating ? <Loader className="login-loader" /> : 'Login'}
                            </button>
                        </div>
                    </form>
                </>
            }
            </div>
        </section>
    )
}

export default Login
